export const nonNill = <T>(v: T): v is NonNullable<T> => {
  return v !== null && v !== undefined;
};
